import { useEffect } from 'react';

const DEFAULT_TITLE =
  'Ghost Text — Mac OCR App to Copy Text from Images, Videos & Screenshots';

// Sets the document title for a route and restores the default on unmount.
export const useDocumentTitle = (title) => {
  useEffect(() => {
    document.title = title;
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
};
